import { FC, useEffect } from 'react'
import styled from 'styled-components'
import { useTranslation, Trans } from 'react-i18next'
import { useRouteError } from 'react-router-dom'
import Layout from '../Layout'
import { Sub, Title, TitleLink } from '../Layout/_styles'
import ChevronLeftIcon from 'components/Common/Icons/ChevronLeft'
import { PrimaryButtonFlexable48 } from 'components/Common/MasterComponents'
import ClearLink from 'components/Common/MasterComponents/ClearLink'
import { captureException } from 'utils/sentry'

const Button = styled(PrimaryButtonFlexable48)`
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.3px;
  display: flex;
  align-items: center;
  padding: 12px 24px;
`

const Error500: FC = () => {
  const { t } = useTranslation()
  const error = useRouteError() as Error

  const errorText = typeof error === 'string' ? error : error?.toString() || ''
  const testErrorMessage = (expr: RegExp) => expr.test(errorText)

  const isLoadChunkError = [
    /ChunkLoadError: Loading.+failed/gm,
    /Failed to fetch dynamically imported module/gm,
    /error loading dynamically imported module/gm,
    /Importing a module script failed/gm,
    /Failed to load module script/gm,
    /SyntaxError: Unexpected token '<'/gm,
  ].some(testErrorMessage)

  if (isLoadChunkError) {
    window.location.reload()
  }

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      captureException(error)
    } else {
      // eslint-disable-next-line no-console
      console.error(error)
    }
  }, [error])

  return (
    <Layout>
      <>
        <Title>
          <Trans
            i18nKey='errorPage.500.title'
            t={t}
            components={[<TitleLink key='link' to='/acc' />]}
          />
        </Title>
        <Sub>{t('errorPage.500.description')}</Sub>
        <ClearLink to='/acc'>
          <Button>
            <ChevronLeftIcon size={25} color='white' />
            <div>{t('errorPage.500.home')}</div>
          </Button>
        </ClearLink>
      </>
    </Layout>
  )
}

export default Error500
